export default "__VITE_ASSET__DyaJDCaU__"